import { type MutableRefObject, useLayoutEffect, useRef, useState } from 'react';

const MIN_INTERVALS = 1;
const MAX_INTERVALS = 6;

/*
 * Вычисляет высоту скролла: берётся максимум из (высота первого элемента × кол-во интервалов)
 * и суммы фактических высот по каждому интервалу; плюс высота разделителей (1px между элементами).
 * Возвращает ref для привязки к элементам списка и вычисленную высоту.
 */
export const useSlotListScrollHeight = (
    intervalsLength: number,
    maxIntervals?: number
): { wrapperHeight: number; labelsRef: MutableRefObject<HTMLDivElement[]> } => {
    const [wrapperHeight, setWrapperHeight] = useState(0);
    const labelsRef = useRef<HTMLDivElement[]>([]);

    useLayoutEffect(() => {
        const intervalsCount = Math.min(Math.max(maxIntervals ?? intervalsLength, MIN_INTERVALS), MAX_INTERVALS);

        const firstEl = labelsRef.current[0];
        const firstItemHeight = firstEl?.offsetHeight ?? 0;
        const heightByFirst = firstItemHeight * intervalsCount + (intervalsCount - 1);

        let sumByIntervals = 0;
        let count = 0;

        for (let i = 0; i < intervalsCount; i++) {
            const el = labelsRef.current[i];

            if (el) {
                sumByIntervals += el.offsetHeight;
                count++;
            }
        }

        const heightByIntervals = count > 0 ? sumByIntervals + (count - 1) : 0;
        const finalHeight = Math.max(heightByFirst, heightByIntervals);

        if (finalHeight > 0) {
            queueMicrotask(() => setWrapperHeight(finalHeight));
        }
    }, [intervalsLength, maxIntervals]);

    return { wrapperHeight, labelsRef };
};
